import React from 'react' ;

const FallbackComponent = ({ error, componentStack, resetErrorBoundary }) => {
    return (
        <div>
            <p>An error occurred: {error.message}</p>
            <button onClick={resetErrorBoundary}>Try again</button>
        </div>
    );
};

export default FallbackComponent;
